import Listausuarios from "./ListaUsuarios/ListaUsuarios";
import CrearUsuarioModal from "./UsuariosModal/CrearUsuario";

function AdminUsuarios() {
    return ( <>
    <Listausuarios/>
</> );
}

export default AdminUsuarios;